import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthMfaRoutingModule } from './auth-mfa-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { AuthMfaComponent } from './auth-mfa/auth-mfa.component';
import { AuthMfaFormComponent } from './auth-mfa-form/auth-mfa-form.component';

@NgModule({
  declarations: [AuthMfaComponent, AuthMfaFormComponent],
  imports: [
    CommonModule,
    AuthMfaRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    PlainToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class AuthMfaModule {}
